import { useCallback, useEffect } from 'react';

import { GoogleLogin } from '@react-oauth/google';
import { Card, message } from 'antd';
import { Spinner } from 'components';
import { useNavigate } from 'react-router-dom';
import { setIsAuth } from 'services/redux/auth/slice';
import { useAppDispatch } from 'services/redux/configureStore';
import { api } from 'services/rtk';
import { authApi } from 'services/rtk/login';
import { usersApi } from 'services/rtk/users';

export default function Login() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { data: me, isSuccess: isFetchMeSuccess } = usersApi.useFetchMeQuery();

  const [login, { data, isLoading, isSuccess, isError }] = authApi.useLoginMutation();

  const sentAuthReqToBackend = useCallback(
    async (credential: string) => {
      await login({ token: credential });
    },
    [login]
  );

  useEffect(() => {
    if (isError) {
      message.error('Ошибка входа. Обратитесь к админстратору');
    }
    if (data && isSuccess) {
      localStorage.setItem('token', data.token);
      dispatch(setIsAuth(true));
      navigate('/me');
    }
  }, [data]);

  useEffect(() => {
    if (me && isFetchMeSuccess) {
      dispatch(api.util.invalidateTags(['Users', 'User']));
      dispatch(setIsAuth(true));
      navigate('/me', { replace: true });
    }
  }, [me, isFetchMeSuccess]);

  return (
    <div className="center-page">
      <Card title="Пожалуйста, авторизируйтесь с помощью гугл аккаунта" bordered={false}>
        {isLoading ? (
          <Spinner />
        ) : (
          <GoogleLogin
            onSuccess={({ credential }) => {
              if (credential) sentAuthReqToBackend(credential);
            }}
            onError={() => message.error('Ошибка гугл сервиса')}
          />
        )}
      </Card>
    </div>
  );
}
